<template lang="pug">
    .profile-image-actions(@click="active = !active" ref="button")
        svg-icon(iconId="pencil")
        .profile-image-actions__menu(:class="{ active }")
            .profile-image-actions__menu-item(@click.stop="select('delete')") Delete
            .profile-image-actions__menu-item(@click.stop="select('change')") Change
</template>

<script>
export default {
    name: 'settings-image-actions',

    data() { return {
        active: false,
    }},

    methods: {
        select(value) {
            this.active = false
            this.$emit(`${value}Photo`)
        },
    },
}
</script>
